import { useCallback } from "react";

const useAuthRedirect = (isAuthenticated, location, loginWithRedirect) => useCallback(() => {
  if (!isAuthenticated) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    sessionStorage.setItem("REDIRECT_AFTER_LOGIN", redirectPath);
    loginWithRedirect();
    return true;
  }
  return false;
}, [isAuthenticated, location, loginWithRedirect]);

export default useAuthRedirect;
